export const formData1 = [
  {
    placeholder: "First Name",
    name: "firstName",
    type: "text",
  },
  {
    placeholder: "Last Name",
    name: "lastName",
    type: "text",
  },
];

export const selectData = [
  {
    placeholder: "Class",
    name: "className",
    options: [
      "Charter",
      "Alpha",
      "Beta",
      "Gamma",
      "Delta",
      "Epsilon",
      "Zeta",
      "Eta",
      "Theta",
      "Iota",
      "Kappa",
      "Lambda",
      "Mu",
      "Nu",
      "Xi",
      "Omicron",
      "Pi",
      "Rho",
      "Sigma",
      "Tau",
      "Upsilon",
      "Phi",
      "Chi",
      "Psi",
      "Alpha Beta",
      "Alpha Gamma",
      "Alpha Delta",
      "Alpha Epsilon",
      "Alpha Zeta",
      "Alpha Eta",
      "Alpha Theta",
      "Alpha Iota",
      "Tau Alpha",
      "Alpha Kappa",
      "Alpha Lambda",
      "Tau Beta",
      "Alpha Mu"
    ],
  },
  {
    placeholder: "Major",
    name: "major",
    options: [
      "Aerospace Engineering",
      "Artificial Intelligence",
      "Bioengineering",
      "Chemical Engineering",
      "Cognitive Science: Machine Learning",
      "Computer Engineering",
      "Computer Science",
      "Data Science",
      "Electrical Engineering",
      "Environmental Engineering",
      "Math-Computer Science",
      "Mechanical Engineering",
      "Nanoengineering",
      "Structural Engineering",
      "Engineering Physics",
    ],
  },
  {
    placeholder: "Year",
    name: "year",
    options: [
      "1st Year",
      "2nd Year",
      "3rd Year",
      "4th Year",
      "5th Year",
      "Alumni",
    ],
  },
];

export const formData2 = [
  {
    placeholder: "Phone (Only enter digits)",
    name: "phone",
    type: "number",
  },
  {
    placeholder: "Email",
    name: "email",
    type: "email",
  },
  {
    placeholder: "Authorization Code",
    name: "code",
    type: "password",
  },
  {
    placeholder: "Password (Must be longer than 6 characters)",
    name: "password",
    type: "password",
  },
  {
    placeholder: "Password Confirmation",
    name: "confirmation",
    type: "password",
  },
];



// WEBPACK FOOTER //
// ./src/containers/Login/data.js